module.exports = __webpack_public_path__ + "img/swiper4.19c9dcd2.png";